

export default function FormLine({ dataTab, activeTab }) {

    const Tab = ({ label, id, index }) => {

        return (
            <div className={"flex flex-col items-center min-w-36 max-w-36" + (activeTab>index ? "" : " opacity-60")}>
                <div className="flex flex-row items-center">
                    <div className={"bg-light-green min-h-[2px] max-h-[2px] min-w-12 max-w-12"+(index !== 0 ?"":" opacity-0")}></div>
                    <div className="border-[3px] border-light-green rounded-full min-w-12 max-w-12 min-h-12 max-h-12 flex"><p className="m-auto text-dark-green font-medium">{id}</p></div>
                    <div className={"bg-light-green min-h-[2px] max-h-[2px] min-w-12 max-w-12"+(index !== dataTab.length-1 ?"":" opacity-0")}></div>
                </div>
                <p className="text-dark-green font-medium text-sm">{label}</p>
            </div>
        )
    }

    return (
        <div className="flex flex-row">
            {dataTab.map((item, index) => <Tab key={item.id} label={item.label} id={item.id} index={index} />)}
        </div>
    )
}